import { css } from 'emotion';
import { theme } from '../Theme';

const htmlContentStyle = css`
  max-width: 60rem;
  margin: 0 auto;
    line-height: 1.4;

  img {
    max-width: 100%;
  }

  h2 {
    margin-top: 2rem;
      font-size: 1.5rem;
  }


  h3 {
    margin-top: 1.5rem;
      font-size: 1.25rem;
  }


  h4 {
    margin-top: 1.25rem;
  }

  h2, h3, h4, h5 {      
      font-weight: bold;
      
    + p {
      margin-top: 0.125rem;
    }
  }

  p {
    margin: 0.625rem 0;
      line-height: 1.4;
  }


  ul, ol {
    margin: 1rem 0;
    padding: 0 0 0 1.5rem;

    li {
      margin: 0.5rem 0 0.5rem 1rem;
    }

  }

  ul {
    list-style: disc;
  }

  ol {
    list-style: decimal;
    counter-reset: list-counter 0;

    li {
      counter-increment: list-counter 1;
    }

    li::marker {
      content: counter(list-counter) '.  ';
      font-weight: 700;
    }

  }

  table {
    border-collapse: collapse;

    tr {

      &:nth-child(even) {
        td {
          background-color: ${theme.colors.gray[5]};
        }
      }

      &:last-child td {
        border-bottom: 1px solid ${theme.colors.gray[1]};
      }

    }

    th, td {
      padding: 0.25rem 0.75rem;
      text-align: left;
      border: 1px solid ${theme.colors.gray[4]};

    }

    td {
      &:first-child {
        border-left: 1px solid ${theme.colors.gray[1]};
      }

      &:last-child {
        border-right: 1px solid ${theme.colors.gray[1]};
      }
    }

    th {
      background-color: ${theme.colors.gray[5]};
      font-weight: ${theme.fontWeights.bold};
        //border: 1px solid ${theme.colors.gray[3]};
      font-size: 1.0625em;
      border-bottom: 1px solid ${theme.colors.gray[1]};
      border-top: 1px solid ${theme.colors.gray[1]};

      &:first-child {
        border-left: 1px solid ${theme.colors.gray[1]};
      }

      &:last-child {
        border-right: 1px solid ${theme.colors.gray[1]};
      }

    }


  }


  code {
    padding: 0.25rem 0.25rem;
    background-color: ${theme.colors.gray[5]};
  }



`;


export default htmlContentStyle;
